/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiatePaymentTestOptions
 */
export interface InitiatePaymentTestOptions {
    /**
     * 
     * @type {string}
     * @memberof InitiatePaymentTestOptions
     */
    adyenAuthorisationResponseCode?: string;
}

/**
 * Check if a given object implements the InitiatePaymentTestOptions interface.
 */
export function instanceOfInitiatePaymentTestOptions(value: object): value is InitiatePaymentTestOptions {
    return true;
}

export function InitiatePaymentTestOptionsFromJSON(json: any): InitiatePaymentTestOptions {
    return InitiatePaymentTestOptionsFromJSONTyped(json, false);
}

export function InitiatePaymentTestOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiatePaymentTestOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'adyenAuthorisationResponseCode': json['adyenAuthorisationResponseCode'] == null ? undefined : json['adyenAuthorisationResponseCode'],
    };
}

export function InitiatePaymentTestOptionsToJSON(json: any): InitiatePaymentTestOptions {
    return InitiatePaymentTestOptionsToJSONTyped(json, false);
}

export function InitiatePaymentTestOptionsToJSONTyped(value?: InitiatePaymentTestOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adyenAuthorisationResponseCode': value['adyenAuthorisationResponseCode'],
    };
}

